import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { getText } from '../../../../internal/TextLabels'
import { CustomerTypeModel } from '../../models/private-models'
import { getDefaultCountry } from '../../../../models/languages'
import styles from './TermsAndSekkiCard.module.scss'

export const TermsAndSekkiCard = ({
  customerType,
  sekki,
  terms,
  country,
  showSekkiDisclaimer,
}) => {
  const filteredSekki = sekki.filter(
    row => country === getDefaultCountry(row.language),
  )
  const filteredTerms = terms.filter(
    row => country === getDefaultCountry(row.language),
  )
  return (
    <div className={styles.termsAndSekkiContainer}>
      <div className={styles.subtitle}>
        {getText('payApply.paymentPerMonth.documentLinks')}
      </div>
      {customerType === CustomerTypeModel.NATURAL &&
        filteredSekki.length &&
        filteredSekki.map(row => (
          <label key={row.uri}>
            <a
              key={row.uri}
              href={row.uri}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText('payApply.paymentPerMonth.sekki')}
            </a>
            {showSekkiDisclaimer &&
              ` ${getText('payApply.paymentPerMonth.sekkiDisclaimer')}`}
            <span>
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </span>
          </label>
        ))}
      {filteredTerms.length &&
        filteredTerms.map(row => (
          <label key={row.uri}>
            <a href={row.uri} target="_blank" rel="noopener noreferrer">
              {getText('payApply.paymentPerMonth.terms')}
            </a>
            <span>
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </span>
          </label>
        ))}
    </div>
  )
}

TermsAndSekkiCard.propTypes = {
  sekki: PropTypes.array,
  terms: PropTypes.array,
}
TermsAndSekkiCard.defaultProps = {
  sekki: [],
  terms: [],
}
